// components/NavBar.js
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function NavBar() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav className="nav">
      <Link to="/" className="nav-link">
        主页
      </Link>
      {isAuthenticated ? (
        <>
          <Link to="/eco-water-report" className="nav-link">
            生成报告
          </Link>
          <Link to="/modify-water-report" className="nav-link">
            修改报告
          </Link>
          <Link to="/update-concentration" className="nav-link">
            更新浓度
          </Link>
          <Link to="/update-water-control" className="nav-link">
            更新控制指标
          </Link>
          <button onClick={logout} className="nav-button">
            退出
          </button>
        </>
      ) : (
        <Link to="/login" className="nav-link">
          登录
        </Link>
      )}
    </nav>
  );
}

export default NavBar;
